import { AxiosError } from 'axios'

const defaultErrorMessage = 'Houve um erro desconhecido'

type PossibleErrors = {
  [key: number | string]: string
}

const handleAxiosErrors = (responseStatus: number | string) => {
  const possibleErros: PossibleErrors = {
    404: 'Rota não encontrada',
  }

  return {
    header: {
      message: possibleErros[responseStatus] || defaultErrorMessage,
      success: false,
    },
  }
}

const handleNetworkError = (error: AxiosError) => {
  let errorMessage = defaultErrorMessage

  if (error.message.includes('timeout')) {
    errorMessage = 'Tempo de resposta so servidor expirou'
  }

  if (error.message === 'Network Error') {
    errorMessage = 'Conexão instável em sua rede'
  }

  return {
    header: {
      message: errorMessage,
      success: false,
    },
  }
}

export default async function formatHttpResponseError(error: AxiosError) {
  if (error?.response?.data) return error.response.data

  if (error?.response?.status) return handleAxiosErrors(error?.response?.status)

  if (error?.message) return handleNetworkError(error)
}
